import { deleteRequest, get, post,} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";



export const getNotificationListFitler = async (): Promise<DataResponse<any>> => {

    const url = `${endpoints.getNotificationList}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const   allReadNotificationList = ()=>{
    const url = `${endpoints.allReadNotificationList}`;
      const config = headers.content_type.application_json;
      return post<DataResponse<any>>(url, {},config);
  }
  
  export const deleteListNotification = (data:any[])=>{
    const url = `${endpoints.deleteListNotification}`;
      const config = headers.content_type.application_json;
      return deleteRequest<DataResponse<any>>(url, data,config);
  }